import Store from "../store/Store";

const PermissionCheck = (type, permission) => {
  const permissionState = Store.getState().auth.permissions;    
  return permissionState?.[type]?.includes?.(permission);
};

export default PermissionCheck;
